import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function MobilePanelHeader({
  itemLeft,
  itemRight,
  title
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    backgroundColor: "fill-field-default",
    marginBlockEnd: "100",
    borderBlockEndWidth: "300",
    borderBlockEndColor: "border-tertiary-default",
    paddingInline: "100",
    children: [/*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      flex: "1",
      children: /*#__PURE__*/_jsx(Text, {
        as: "span",
        marginInlineEnd: "auto",
        textAlign: "center",
        color: "text-core-default",
        children: itemLeft
      })
    }), /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      flex: "1",
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        marginBlockEnd: "0",
        typography: "heading-100",
        textAlign: "center",
        color: "text-core-default",
        children: title
      })
    }), /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      flex: "1",
      children: /*#__PURE__*/_jsx(Text, {
        as: "span",
        marginInlineStart: "auto",
        textAlign: "center",
        color: "text-core-default",
        children: itemRight
      })
    })]
  });
}